<button mat-raised-button *appRole="['FormasPago.Crear']" color="primary" [routerLink]="['/formaspago']">
  <mat-icon>add</mat-icon>
  Nueva forma de pago
</button>
